import { z } from 'zod'

export const instagramInstantwinPretestLotteryResultSchema = z.enum(['win', 'lose'])

export const instagramInstantwinPretestExpirationMinutesSchema = z.union([
  z.literal(5),
  z.literal(30),
  z.literal(60),
  z.literal(180)
])

export const instagramInstantwinPretestEntryCodeParamsSchema = z.object({
  prizeId: z.number().int().positive()
})

export const instagramInstantwinPretestEntryCodeSchema = z.object({
  prizeId: z.number(),
  code: z.string(),
  lotteryResult: instagramInstantwinPretestLotteryResultSchema,
  expiresAt: z.string(),
  remainingMinutes: z.number().int(),
  isExpired: z.boolean(),
  expirationMinutes: instagramInstantwinPretestExpirationMinutesSchema
})

export const instagramInstantwinPretestEntryCodeResponseSchema = z.object({
  data: instagramInstantwinPretestEntryCodeSchema.nullable()
})

export const issueInstagramInstantwinPretestEntryCodeRequestSchema = z.object({
  lotteryResult: instagramInstantwinPretestLotteryResultSchema,
  expirationMinutes: instagramInstantwinPretestExpirationMinutesSchema
})

export const issueInstagramInstantwinPretestEntryCodeParamsSchema =
  instagramInstantwinPretestEntryCodeParamsSchema.extend({
    lotteryResult: instagramInstantwinPretestLotteryResultSchema,
    expirationMinutes: instagramInstantwinPretestExpirationMinutesSchema
  })

export type InstagramInstantwinPretestEntryCodeParams = z.infer<typeof instagramInstantwinPretestEntryCodeParamsSchema>
export type InstagramInstantwinPretestLotteryResult = z.infer<typeof instagramInstantwinPretestLotteryResultSchema>
export type InstagramInstantwinPretestExpirationMinutes = z.infer<
  typeof instagramInstantwinPretestExpirationMinutesSchema
>
export type InstagramInstantwinPretestEntryCode = z.infer<typeof instagramInstantwinPretestEntryCodeSchema>
export type InstagramInstantwinPretestEntryCodeResponse = z.infer<
  typeof instagramInstantwinPretestEntryCodeResponseSchema
>
export type IssueInstagramInstantwinPretestEntryCodeRequest = z.infer<
  typeof issueInstagramInstantwinPretestEntryCodeRequestSchema
>
export type IssueInstagramInstantwinPretestEntryCodeParams = z.infer<
  typeof issueInstagramInstantwinPretestEntryCodeParamsSchema
>

export const parseInstagramInstantwinPretestEntryCodeResponse = (
  input: unknown
): InstagramInstantwinPretestEntryCodeResponse => {
  return instagramInstantwinPretestEntryCodeResponseSchema.parse(input)
}

export const parseIssueInstagramInstantwinPretestEntryCodeRequest = (
  input: unknown
): IssueInstagramInstantwinPretestEntryCodeRequest => {
  return issueInstagramInstantwinPretestEntryCodeRequestSchema.parse(input)
}

export const normalizeInstagramInstantwinPretestEntryCode = (
  input: InstagramInstantwinPretestEntryCode | null
): InstagramInstantwinPretestEntryCode | null => {
  if (!input) {
    return null
  }

  return {
    ...input,
    remainingMinutes: Math.max(input.remainingMinutes, 0)
  }
}
